import { render, staticRenderFns } from "./vue-wave-surfer.vue?vue&type=template&id=5462d44c&scoped=true"
import script from "./vue-wave-surfer.vue?vue&type=script&lang=js"
export * from "./vue-wave-surfer.vue?vue&type=script&lang=js"
import style0 from "./vue-wave-surfer.vue?vue&type=style&index=0&id=5462d44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462d44c",
  null
  
)

export default component.exports